export default "/_next/static/chunks/fonts/WhitneySSm-LightItalic-Pro_Web-0a31108b031b00358966ba80c315071d.woff";